module.exports = __webpack_public_path__ + "sj.svg?f40433689ccd69fe698f04d5d27baf44";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/sj.svg
// module id = 1356
// module chunks = 0